import { BasePlugin } from "./base";

export class SemiboldPlugin extends BasePlugin {
  constructor(protected tinymce) {
    super(tinymce);
  }

  public create() {
    this.tinymce.PluginManager.add("semibold", (editor) => {
      // Register the formatter when the editor is initialized
      editor.on('init', function() {
        editor.formatter.register('semibold', {
          inline: 'span',
          styles: { 'font-weight': '600' }
        });
      });

      // Add semibold toggle button
      editor.ui.registry.addToggleButton('semibold', {
        text: 'SB',
        tooltip: 'Semi Bold',
        onAction: function() {
          // Check if text is currently bold before applying semibold
          const isBold = editor.formatter.match('bold');
          const isSemibold = editor.formatter.match('semibold');
          
          // If applying semibold and text is currently bold, remove bold first
          if (!isSemibold && isBold) {
            editor.formatter.remove('bold');
          }
          
          editor.formatter.toggle('semibold');
          editor.fire('Change');
        },
        onSetup: function(api) {
          const updateButtonState = () => {
            const isActive = editor.formatter.match('semibold');
            api.setActive(isActive);
          };
          
          editor.formatter.formatChanged('semibold', updateButtonState, false);
          editor.on('NodeChange', updateButtonState);
          
          return function() {
            editor.off('NodeChange', updateButtonState);
          };
        }
      });
    });
  }
}